// extracted by mini-css-extract-plugin
export default {"viewRoles":"style_viewRoles__af-jL"};